module.exports = __webpack_public_path__ + "img/left-angle.f02c8d79.svg";